<!-- Modal for MFA enrollment - Desktop -->
@if (isDesktopView()) {
<p-dialog
  [(visible)]="visible"
  [draggable]="false"
  [resizable]="false"
  [modal]="true"
  [closable]="true"
  [appendTo]="'body'"
  [baseZIndex]="20000"
  styleClass="mfa-dialog"
  (onHide)="close()"
  >
  <ng-template pTemplate="header">
    <div class="dialog-header" [attr.data-subtitle]="'profile.mfa.subtitle' | transloco">
      <span class="dialog-title">{{ 'profile.mfa.enrollTitle' | transloco }}</span>
    </div>
  </ng-template>

  <div class="mfa-enrollment-content">
    <p class="mfa-instruction">{{ 'profile.mfa.scanQrCode' | transloco }}</p>

    <app-spinner [loading]="isEnrollingMfa">
      <div class="qr-code-container">
        @if (mfaQrCode) {
          <img [src]="mfaQrCode" [alt]="'common.a11y.qrCode' | transloco" class="qr-code-image" />
        } @else {
          <div class="qr-code-placeholder"></div>
        }
      </div>
    </app-spinner>

    @if (mfaSecret) {
      <div class="mfa-secret-container">
        <p class="mfa-secret-label">{{ 'profile.mfa.manualEntry' | transloco }}</p>
        <code class="mfa-secret">{{ mfaSecret }}</code>
      </div>
    }

    <div class="mfa-verification">
      <p class="mfa-code-label">{{ 'profile.mfa.verificationCode' | transloco }}</p>
      <div class="mfa-code-boxes" (paste)="onMfaPaste($event)">
        @for (digit of mfaCodeDigits; track $index) {
          <input
            type="text"
            inputmode="numeric"
            pattern="[0-9]"
            maxlength="1"
            [id]="'mfa-digit-' + $index"
            [value]="digit"
            (input)="onMfaDigitInput($event, $index)"
            (keydown)="onMfaDigitKeydown($event, $index)"
            class="mfa-code-input"
            autocomplete="off"
            />
        }
      </div>
    </div>

    <div class="mfa-actions">
      <app-button
        [label]="isVerifyingMfa ? ('common.labels.loading' | transloco) : ('profile.mfa.verify' | transloco)"
        type="button"
        size="medium"
        (click)="verifyMfaCode()"
        [disabled]="isVerifyingMfa"
      ></app-button>
      <app-button
        [label]="'common.actions.cancel' | transloco"
        variant="tertiary"
        type="button"
        size="medium"
        (click)="close()"
        [disabled]="isVerifyingMfa"
      ></app-button>
    </div>
  </div>
</p-dialog>
} @else if (visible) {
  <!-- Modal for MFA enrollment - Responsive -->
  <div class="mfa-modal-overlay-responsive" animate.leave="bt-sheet-leave" (click)="close()">
    <div class="mfa-modal-container-responsive bt-sheet" (click)="$event.stopPropagation()">
      <div class="mfa-modal-header">
        <h3>{{ 'profile.mfa.enrollTitle' | transloco }}</h3>
        <button type="button" class="close-btn" (click)="close()" [attr.aria-label]="'common.actions.close' | transloco">
          <lucide-icon name="X"></lucide-icon>
        </button>
      </div>
      <div class="mfa-enrollment-content">
        <p class="mfa-instruction">{{ 'profile.mfa.scanQrCode' | transloco }}</p>
        <app-spinner [loading]="isEnrollingMfa">
          <div class="qr-code-container">
            @if (mfaQrCode) {
              <img [src]="mfaQrCode" [alt]="'common.a11y.qrCode' | transloco" class="qr-code-image" />
            } @else {
              <div class="qr-code-placeholder"></div>
            }
          </div>
        </app-spinner>
        @if (mfaSecret) {
          <div class="mfa-secret-container">
            <p class="mfa-secret-label">{{ 'profile.mfa.manualEntry' | transloco }}</p>
            <code class="mfa-secret">{{ mfaSecret }}</code>
          </div>
        }
        <div class="mfa-verification">
          <p class="mfa-code-label">{{ 'profile.mfa.verificationCode' | transloco }}</p>
          <div class="mfa-code-boxes" (paste)="onMfaPaste($event)">
            @for (digit of mfaCodeDigits; track $index) {
              <input
                type="text"
                inputmode="numeric"
                pattern="[0-9]"
                maxlength="1"
                [id]="'mfa-digit-' + $index"
                [value]="digit"
                (input)="onMfaDigitInput($event, $index)"
                (keydown)="onMfaDigitKeydown($event, $index)"
                class="mfa-code-input"
                autocomplete="off"
                />
            }
          </div>
        </div>
        <div class="mfa-actions">
          <app-button
            [label]="isVerifyingMfa ? ('common.labels.loading' | transloco) : ('profile.mfa.verify' | transloco)"
            type="button"
            size="medium"
            (click)="verifyMfaCode()"
            [disabled]="isVerifyingMfa"
          ></app-button>
          <app-button
            [label]="'common.actions.cancel' | transloco"
            variant="tertiary"
            type="button"
            size="medium"
            (click)="close()"
            [disabled]="isVerifyingMfa"
          ></app-button>
        </div>
      </div>
    </div>
  </div>
}
